import React from 'react';

function Header() {
    return (
        <header className="header">
            <div className="header-top">
                <div className="header-left"></div>
                
                <div className="header-center">
                    <div className="logo-wrapper-center">
                        <img 
                            src="/lufthansa-logo.png" 
                            alt="Lufthansa" 
                            className="header-logo-center"
                            onError={(e) => {
                                e.target.style.display = 'none';
                                const fallback = document.createElement('span');
                                fallback.className = 'logo-placeholder-fallback-center';
                                fallback.textContent = '✈️';
                                e.target.parentElement.appendChild(fallback);
                            }}
                        />
                    </div>
                </div>
                
                <div className="header-right"></div>
            </div>
            <div className="header-bottom">
                <h2 className="app-name">Roster<span>X</span></h2>
            </div>
        </header>
    );
}

export default Header;